import React from 'react';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InfoCircleRegularIcon(props) {
  return <FontAwesomeIcon icon={faInfoCircle} {...props} />;
}
